import type * as React from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';

import { AnimateLifecycle } from '../../Animate';
import { isPaletteOpenedSelector, openedPaletteAtom } from '../state';
import { PaletteView } from './PaletteView';

/**
 * Singleton component to render the current palette.
 */
export function Palette(): React.ReactElement | null {
    const [palette, setPalette] = useRecoilState(openedPaletteAtom);

    return (
        <AnimateLifecycle>
            {palette ? <PaletteView paletteState={palette} setPaletteState={setPalette} /> : null}
        </AnimateLifecycle>
    );
}

export function useIsPaletteOpened() {
    return useRecoilValue(isPaletteOpenedSelector);
}
